export var PRESENTATION_CONTEXT;
(function (PRESENTATION_CONTEXT) {
    PRESENTATION_CONTEXT["PUBLISHER"] = "PUBLISHER";
    PRESENTATION_CONTEXT["APP"] = "APP";
})(PRESENTATION_CONTEXT || (PRESENTATION_CONTEXT = {}));
//# sourceMappingURL=types.js.map